import React from 'react';
import AppLayout from '../components/AppLayout';
import OverviewList,{MiniList} from '../components/OverviewList';
import {PageMenu,DeleteListItem,GenerateSpreadsheet,
        DownloadTemplate,DynamicListArea,BulkEdit,
        LoadGraphic,AddListItem,Step,Dropzone} from '../components/Common';
import {Input,TextButton,Button,InputPhoto,CheckboxList} from '../components/Input';
import u from '../utilities/Utilities';
import {Attachment} from '../data/Mimetypes';
import moment from 'moment';

export default class AppointmentAssignList extends React.Component{
    r={};

    settings={
        /**** Page Setup ****/
        title:"Assigned Appointments",
        permission:"appointment",  //Accepts combined permission module as well
        //combinedField:"",          //Used when permission exists in a combined field
        url:"/appointment-assigned-list",

        /**** Action Setup ****/
        addType:0,
        addURL:"/api/add-appointment-assign-entry",
        deleteURL:"/api/delete-appointment-assign-entries",
        spreadsheetURL:"/api/generate-appointment-assign-spreadsheet",
        overviewURL:"/api/get-all-appointment-assign-entries",

        /**** List Setup ****/
        list:true,
        listLabel:"appointment-assigned-list",
        orderByField:"createdOn",
        orderByType:"descending",
        numRows:20,
        checkboxPermissions:{},
        overview:undefined,
        onPopup:(content)=>{this.r['layout'].onPopup(content)}
    };

    pageComponents={
        add:{component:AddEntry,props:{}},
        delete:{component:DeleteListItem,props:{}},
        download:{component:DownloadTemplate,props:{skipParams:true}},
        spreadsheet:{component:GenerateSpreadsheet,props:{}},
        bulkEdit:{component:BulkEdit,props:{}},
    };

    state={
        selected:{
            tags:[],
            all:false,
            data:[],
            entryCount:0
        },
        pageMenuButtons:[],
        permissions:{},
    };

    componentDidMount=()=>{
        const permissions = u.getPermissions(this.settings.permission);
        const bulkEditOptions = u.getBulkEdit(this.settings.listLabel);
        const bulkEditEnabled = (permissions.update == 2 && bulkEditOptions.length > 0);
        this.setState({
            permissions:permissions,
            pageMenuButtons:[
                {label:"Add Entry",ref:"add",enabled:(permissions.create==2)},
                {label:"Delete Entries",ref:"delete",enabled:(permissions.delete==2)},
                {label:"Generate Spreadsheet",ref:"spreadsheet",enabled:true},
                {label:"Bulk Edit",ref:"bulkEdit",enabled:bulkEditEnabled,padding:"3px"},
                {label:"Configure Appointments",ref:"configureAppt",enabled:(permissions.update==2),onClick:this.onConfigureAppointment},
            ]
        })
    };

    onSelectChange=(selected)=>{
        this.setState({selected:selected});
    };

    onConfigureAppointment=()=>{
        window.open("/appointment-list","_blank");
    }

    render=()=>{
        return (
            <AppLayout ref={(ref)=>{this.r["layout"]=ref}} settings={this.settings}>

                <div className="page-error">{this.state.error}</div>

                <PageMenu ref={(ref)=>{this.r['pageMenu']=ref}}
                          buttons={this.state.pageMenuButtons}
                          settings={this.settings}
                          components={this.pageComponents}
                          selected={this.state.selected}
                          />

                <OverviewList ref={(ref)=>{this.settings.overview=ref}}
                              settings={this.settings}
                              onSelectChange={this.onSelectChange}
                              registerReference={this.registerReference}
                              onMutatedChange={this.onMutatedChange}
                              location={this.props.location}>
                    {
                        (content,index,onChange,onContentChange,registerRef)=>{
                            return (
                                <ListItem key={index}
                                          index={index}
                                          content={content}
                                          onChange={onChange}
                                          onContentChange={onContentChange}
                                          registerReference={registerRef}
                                          permissions={this.state.permissions}
                                          settings={this.settings}
                                          />
                            )
                        }
                    }
                </OverviewList>
            </AppLayout>
        )
    }
}

class ListItem extends React.Component{

    state={
        error:"",
        step:"view",
        loading:false,
        loadText:"",
    };

    checkOverallCondition=(criteria)=>{
        const checkArray = criteria.selected.filter((line)=>{
            return line.conditionMet;
        });

        if(criteria.logic == "All"){
            const allCondition = checkArray.length == criteria.selected.length;
            return (criteria.type == "Disqualifying") ? !allCondition : allCondition;
        }
        else{
            const anyCondition = checkArray.length > 0;
            return (criteria.type == "Disqualifying") ? !anyCondition : anyCondition;
        }

    }

    checkEntryCondition=()=>{
        const {content}=this.props;
        if(typeof content.criterion == "undefined" || content.criterion == null){
            return false;
        }
        const conditions = content.criterion.filter((item)=>{
            return this.checkOverallCondition(item);
        });
        return conditions.length == content.criterion.length;
    }

    getCriteria=async ()=>{
        const {content}=this.props;
        const response = await u.postAsync({
            url:"/api/get-appointment-assign-criteria",
            data:{
                apptAssignedID:content.apptAssignedID
            }
        });
        this.props.onChange(response.data,"criterion",this.props.index);
        this.props.onChange(true,"polled",this.props.index);
    }

    render=()=>{
        const {content,settings,permissions} = this.props;
        const entryCondition = this.checkEntryCondition();

        return (
            <div style={{textAlign:"center"}}>

                <LoadGraphic active={this.state.loading} text={this.state.loadText}/>
                <div className="list-segment-error">{this.state.error}</div>

                <Step active={this.state.step=="view"}>
                    <DynamicListArea listLabel={settings.listLabel}
                                    permission={settings.permission}
                                    content={content}
                                    onChange={this.props.onChange}
                                    index={this.props.index}
                                    />

                    <div>
                    {
                        (content.polled==true)
                            ?
                            <div>
                                {
                                    (
                                        (content.criterion.length)
                                            ?
                                            content.criterion.map((item,index)=>{
                                                return (
                                                    <div className='criteria-container' key={index}>
                                                        <h3>Criteria {index+1} - {item.type} {item.field} </h3>

                                                        <CheckboxList headers={[
                                                                        {label:item.type + " " + item.field + " (" + item.logic + ")",value:"label"},
                                                                        {label:"Met",value:"conditionMet",style:{width:"50px"},type:"boolToYesNo"},
                                                                    ]}
                                                                    content={item.selected.map((row)=>{
                                                                            row.color = ((item.type=="Disqualifying" && row.conditionMet) || (item.type == "Required" && !row.conditionMet) ? "#ff0000" : "#3b3b3c");
                                                                            return row;
                                                                    })}
                                                                    style={{width:"500px"}}
                                                                    />
                                                    </div>
                                                )
                                            })
                                            :
                                            <div className='list-placeholder'>
                                                <b>No Criteria Attached</b>
                                                <div>Click below to add critera</div>
                                            </div>
                                    )
                                }
                                <h3>Appointment Holder Status: {(entryCondition) ? <span className='text-emphasis'>Qualified</span> : <span className='text-negative'>Not Qualified</span>}</h3>
                            </div>
                            :
                            <div style={{margin:"30px auto"}}>
                                <Button onClick={this.getCriteria}>Check Criteria Condition</Button>
                            </div>
                    }
                    </div>

                    <div className='list-segment-note' style={{margin:"30px auto 10px auto"}}>
                        Criteria conditions are only updated once per day
                    </div>
                </Step>
            </div>
        )
    }
}

class AddEntry extends React.Component{

    settings={
        addType:0,
        addURL:"/api/add-appointment-assign-entry",
        bulkURL:"/api/add-bulk-appointment-assign-entries",
        templateURL:"/api/get-add-appointment-assign-template",
    };

    r={};

    state={
        step:"add",
        entryData:{},
        options:{},
        appointmentOptions:[],
    }

    show=(show)=>{
        this.r[this.props.reference].show(show);
        if(!show){
            this.setState({error:""});
        }
    }

    componentDidMount=()=>{
        this.getOptions();
        this.getAppointmentOptions();

        this.show(this.props.active);
    }

    getOptions=async ()=>{
        try{
            const response=await u.postAsync({
                url:"/api/get-options",
                data:{
                    keys:[
                        "entryType"
                    ]
                }
            });

            this.setState({options:response.data});
        }
        catch(e){
            const {error,status}=u.processError(e);
            this.setState({error:error});
        }
    }

    getAppointmentOptions=async ()=>{
        try{
            const response=await u.postAsync({url:"/api/get-appointment-options"});
            this.setState({appointmentOptions:response.data});
        }
        catch(e){
            const {error,status}=u.processError(e);
            this.setState({error:error});
        }
    }

    onCancel=()=>{
        this.props.onToggleForm(this.props.reference,false);
    }

    onConfirm=(fields)=>{
        const keys = fields.map((item)=>{return item.field});
        let data = {};
        for(var i=0; i<keys.length; i++){
            if(this.r[keys[i]]){
                const current=this.r[keys[i]].validate();
                if(!current.valid){
                    this.setState({error:current.value});
                    return 0;
                }
                data[keys[i]]=current.value;
            }
        }
        const {entryData}=this.state;
        this.settings.overview=this.props.settings.overview;
        this.r[this.props.reference].onValidated({...entryData,...data});
    }

    onComplete=()=>{
        this.setState({
            entryData:{},
            step:"add"
        });

        if(this.props.onComplete){
            this.props.onComplete();
        }
    }

    onChange=(value,label,index)=>{
        let {entryData}=this.state;
        entryData[label]=value;
        this.setState({entryData:entryData});
    }

    onBulkUpload=()=>{
        this.settings.overview=this.props.settings.overview;
        this.r[this.props.reference].onBulkUpload()
    }

    render=()=>{
        const {loading,loadText,step,options,entryData,appointmentOptions}=this.state;

        const fields=[
            {dataType:"select",label:"Entry Type",field:"entryType",rules:{required:true,defaultValue:this.props.entryType},options:options.entryType,enabled:(this.props.entryType) ? false : true},
            {dataType:"box",label:"NRIC/FIN",field:"searchParam",rules:{required:true,defaultValue:this.props.targetID}, enabled:(this.props.targetID) ? false : true},
            {dataType:"select",label:"Appointment",field:"appointmentID",options:appointmentOptions},
        ];

        return (
            <AddListItem ref={(ref)=>{this.r[this.props.reference]=ref}}
                         reference={this.props.reference}
                         settings={this.settings}
                         onComplete={this.onComplete}
                         uploadAsJson={false}
                         inList={this.props.miniList}
                         onToggleForm={this.props.onToggleForm}
                         >

                <div className='segment-content'>
                    <LoadGraphic active={loading} text={loadText}/>
                    <Step active={step=="add"}>
                        <h3>Complete the following fields to create entry</h3>
                        {
                            fields.map(
                                (item,index)=>{
                                    return (
                                        <Input key={index}
                                               ref={(ref)=>{this.r[item.field]=ref}}
                                               values={{
                                                    options:item.options,
                                                    value:entryData[item.field]
                                               }}
                                               fields={{
                                                ...item,
                                                onChange:this.onChange
                                               }}
                                               rules={item.rules}
                                               labelStyle={{width:"40%"}}
                                               inputStyle={{width:"57%"}}
                                               />
                                    )
                                }
                            )
                        }
                        <div style={{margin:"20px auto",fontSize:"14px"}}>
                            <TextButton onClick={this.onBulkUpload}>Bulk Upload</TextButton>
                        </div>
                        <div style={{margin:"20px auto"}}>
                            <div className='page-error'>{this.state.error}</div>
                            <Button onClick={this.onCancel}>Cancel</Button>
                            <Button onClick={()=>{this.onConfirm(fields)}}>Confirm</Button>
                        </div>
                    </Step>
                </div>

            </AddListItem>
        )
    }
}

export class MiniAppointmentAssignList extends React.Component{
    r={};

    settings={
         /**** Page Setup ****/
         title:"Assigned Appointments",
         permission:"appointment",  //Accepts combined permission module as well
         //combinedField:"",          //Used when permission exists in a combined field
         url:"/appointment-assigned-list",

         /**** Action Setup ****/
         addType:0,
         addURL:"/api/add-appointment-assign-entry",
         deleteURL:"/api/delete-appointment-assign-entries",
         spreadsheetURL:"/api/generate-appointment-assign-spreadsheet",
         overviewURL:"/api/get-all-appointment-assign-entries",

         /**** List Setup ****/
         list:true,
         listLabel:"appointment-assigned-list",
         orderByField:"createdOn",
         orderByType:"descending",
    };

    refresh=()=>{
        this.r['list'].refresh();
    }

    render=()=>{
        return(
            <MiniList ref={(ref)=>{this.r["list"]=ref}}
                      settings={this.settings}
                      tags={this.props.tags}
                      pageLength={this.props.pageLength}
                      orderByField={this.props.orderByField}
                      orderByType={this.props.orderByType}
                      addComponent={AddEntry}
                      addProps={this.props.addProps}
                      />
        )
    }
}